import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-slate-900 text-white flex flex-col items-center justify-center px-5 py-16">
      <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 h-96 w-[40rem] rounded-full bg-sky-500/20 blur-3xl" />
      <Link
        to="/"
        className="relative z-10 mb-10 inline-flex items-center gap-2 font-display font-extrabold text-lg"
      >
        <img
          src="/images/logo.png"
          alt="Action Packed Adventures logo"
          className="h-9 w-9 rounded-full object-cover"
        />
        Action Packed <span className="text-sky-400">Adventures</span>
      </Link>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        data-testid="payment-cancel-card"
        className="relative z-10 w-full max-w-lg rounded-[2rem] bg-white/5 border border-white/10 p-8 md:p-10 text-center backdrop-blur-xl"
      >
        <XCircle className="h-14 w-14 mx-auto text-slate-400" />
        <h1 className="mt-6 font-display font-black text-3xl md:text-4xl">
          Booking not completed
        </h1>
        <p className="mt-3 text-slate-300 font-medium">
          No payment has been taken. Your details are safe — you can pick up
          where you left off whenever you are ready.
        </p>
        <Link
          to="/#booking"
          data-testid="try-again-link"
          className="mt-8 inline-flex items-center justify-center rounded-full bg-sky-400 px-8 py-3.5 font-display font-bold text-slate-900 hover:bg-sky-300 transition-colors"
        >
          Back to booking
        </Link>
      </motion.div>
    </div>
  );
}
